import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Code2,
  ChevronDown,
  ChevronUp,
  Cpu,
  FileJson,
  ShieldCheck,
  AlertTriangle,
  Info,
  Hash,
  CheckSquare,
  Layers
} from 'lucide-react';

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ReviewGate
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4">
            <h3 className="font-semibold text-gray-800 mb-3">Motivo rigetto</h3>
            <textarea
              value={rejectReason}
              onChange={e => setRejectReason(e.target.value)}
              placeholder="Descrivi il problema con questa execution..."
              className="w-full border border-gray-300 rounded-lg p-3 text-sm resize-none h-32 focus:ring-2 focus:ring-red-300 focus:outline-none"
            />
            <div className="flex gap-3 mt-4">
              <button onClick={handleReject} disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
                Conferma Rigetto
              </button>
              <button onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors">
                Annulla
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// IRHeader â€” summary banner
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const IRHeader = ({ renderIr, compilationMetadata }) => {
  const layerCount = Object.keys(renderIr || {}).length;
  const irVersion = compilationMetadata?.ir_version || compilationMetadata?.version || 'â€”';
  const compiledAt = compilationMetadata?.compiled_at || compilationMetadata?.timestamp || null;
  const sourceContract = compilationMetadata?.source_contract || 'C16';
  const strategy = compilationMetadata?.compilation_strategy || compilationMetadata?.strategy || 'â€”';

  return (
    <div className="bg-gradient-to-r from-violet-600 to-indigo-600 rounded-xl p-5 text-white">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Cpu className="w-5 h-5 opacity-80" />
            <span className="text-sm font-medium opacity-80 uppercase tracking-wide">Render IR</span>
          </div>
          <h2 className="text-xl font-bold">Intermediate Representation</h2>
          <p className="text-sm opacity-75 mt-1">Renderer-agnostic canonical compilation</p>
        </div>
        <div className="text-right shrink-0">
          <div className="text-2xl font-bold">{layerCount}</div>
          <div className="text-xs opacity-75">IR sections</div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3 mt-4 text-sm">
        <div className="bg-white/10 rounded-lg p-2">
          <div className="opacity-70 text-xs mb-0.5">IR Version</div>
          <div className="font-semibold">{irVersion}</div>
        </div>
        <div className="bg-white/10 rounded-lg p-2">
          <div className="opacity-70 text-xs mb-0.5">Source</div>
          <div className="font-semibold">{sourceContract}</div>
        </div>
        <div className="bg-white/10 rounded-lg p-2">
          <div className="opacity-70 text-xs mb-0.5">Strategy</div>
          <div className="font-semibold truncate">{strategy}</div>
        </div>
      </div>
      {compiledAt && (
        <div className="mt-2 text-xs opacity-60">
          Compiled: {new Date(compiledAt).toLocaleString('it-IT')}
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// IRSectionCard â€” collapsible JSON block per sezione render_ir
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const IRSectionCard = ({ sectionKey, sectionData, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  const labelMap = {
    execution_graph:   { label: 'Execution Graph',    color: 'bg-violet-100 text-violet-700 border-violet-200' },
    script_layer:      { label: 'Script Layer',        color: 'bg-blue-100 text-blue-700 border-blue-200' },
    identity_layer:    { label: 'Identity Layer',      color: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
    motion_layer:      { label: 'Motion Layer',        color: 'bg-orange-100 text-orange-700 border-orange-200' },
    rendering_layer:   { label: 'Rendering Layer',     color: 'bg-pink-100 text-pink-700 border-pink-200' },
    environment_layer: { label: 'Environment Layer',   color: 'bg-teal-100 text-teal-700 border-teal-200' },
    constraint_layer:  { label: 'Constraint Layer',    color: 'bg-red-100 text-red-700 border-red-200' },
    timing_layer:      { label: 'Timing Layer',        color: 'bg-amber-100 text-amber-700 border-amber-200' },
    dependency_graph:  { label: 'Dependency Graph',    color: 'bg-cyan-100 text-cyan-700 border-cyan-200' },
    validation_hooks:  { label: 'Validation Hooks',    color: 'bg-slate-100 text-slate-700 border-slate-200' },
  };

  const meta = labelMap[sectionKey] || {
    label: sectionKey.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
    color: 'bg-gray-100 text-gray-700 border-gray-200'
  };

  const dataSize = JSON.stringify(sectionData || {}).length;

  return (
    <div className={`border rounded-lg overflow-hidden ${meta.color.split(' ').find(c => c.startsWith('border'))}`}>
      <button
        onClick={() => setOpen(o => !o)}
        className={`w-full flex items-center justify-between px-4 py-3 ${meta.color} hover:opacity-90 transition-opacity`}
      >
        <div className="flex items-center gap-2">
          <FileJson className="w-4 h-4" />
          <span className="font-medium text-sm">{meta.label}</span>
          <span className="text-xs opacity-60 font-mono">{dataSize} chars</span>
        </div>
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {open && (
        <div className="bg-gray-950 p-4 overflow-x-auto">
          <pre className="text-xs text-green-300 font-mono whitespace-pre-wrap break-all leading-relaxed">
            {JSON.stringify(sectionData, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// MetadataCard â€” key/value grid
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const MetadataCard = ({ compilationMetadata }) => {
  const meta = compilationMetadata || {};

  const entries = Object.entries(meta).filter(([, v]) => typeof v !== 'object' || v === null);
  const nested = Object.entries(meta).filter(([, v]) => typeof v === 'object' && v !== null);

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <Hash className="w-5 h-5 text-indigo-500" />
        <h3 className="font-semibold text-gray-800">Compilation Metadata</h3>
      </div>

      {entries.length > 0 && (
        <dl className="grid grid-cols-2 gap-x-6 gap-y-2 mb-3">
          {entries.map(([k, v]) => (
            <div key={k}>
              <dt className="text-xs text-gray-400 capitalize">{k.replace(/_/g, ' ')}</dt>
              <dd className="text-sm font-medium text-gray-800 break-words">{String(v)}</dd>
            </div>
          ))}
        </dl>
      )}

      {nested.map(([k, v]) => (
        <div key={k} className="mt-3 border-t border-gray-100 pt-3">
          <div className="text-xs text-gray-500 font-medium uppercase mb-1">{k.replace(/_/g, ' ')}</div>
          <pre className="text-xs text-gray-700 bg-gray-50 rounded p-2 overflow-x-auto">
            {JSON.stringify(v, null, 2)}
          </pre>
        </div>
      ))}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ValidationCard
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ValidationCard = ({ compilationValidation }) => {
  const val = compilationValidation || {};
  const passed = val.passed ?? val.is_valid ?? val.valid ?? null;
  const errors = val.errors || val.validation_errors || [];
  const warnings = val.warnings || val.validation_warnings || [];
  const checks = val.checks || val.validation_checks || [];

  const statusColor = passed === true
    ? 'bg-green-50 border-green-200'
    : passed === false
    ? 'bg-red-50 border-red-200'
    : 'bg-gray-50 border-gray-200';

  const StatusIcon = passed === true ? ShieldCheck : passed === false ? AlertTriangle : Info;
  const statusIconColor = passed === true ? 'text-green-600' : passed === false ? 'text-red-600' : 'text-gray-500';

  return (
    <div className={`border rounded-xl p-5 ${statusColor}`}>
      <div className="flex items-center gap-2 mb-4">
        <StatusIcon className={`w-5 h-5 ${statusIconColor}`} />
        <h3 className="font-semibold text-gray-800">Compilation Validation</h3>
        {passed !== null && (
          <span className={`ml-auto text-xs font-bold px-2 py-0.5 rounded-full ${passed ? 'bg-green-600 text-white' : 'bg-red-600 text-white'}`}>
            {passed ? 'PASSED' : 'FAILED'}
          </span>
        )}
      </div>

      {checks.length > 0 && (
        <div className="mb-3">
          <div className="text-xs text-gray-500 font-medium uppercase mb-1">Checks</div>
          <ul className="space-y-1">
            {checks.map((check, i) => {
              const isObj = typeof check === 'object';
              const name = isObj ? (check.name || check.check || JSON.stringify(check)) : String(check);
              const ok = isObj ? (check.passed ?? check.ok ?? check.valid ?? true) : true;
              return (
                <li key={i} className="flex items-center gap-2 text-sm">
                  <CheckSquare className={`w-3.5 h-3.5 shrink-0 ${ok ? 'text-green-500' : 'text-red-500'}`} />
                  <span className="text-gray-700">{name}</span>
                </li>
              );
            })}
          </ul>
        </div>
      )}

      {errors.length > 0 && (
        <div className="mb-3">
          <div className="text-xs text-red-600 font-medium uppercase mb-1">Errors ({errors.length})</div>
          <ul className="space-y-1">
            {errors.map((e, i) => (
              <li key={i} className="text-sm text-red-700 bg-red-100 rounded px-2 py-1">
                {typeof e === 'object' ? JSON.stringify(e) : e}
              </li>
            ))}
          </ul>
        </div>
      )}

      {warnings.length > 0 && (
        <div>
          <div className="text-xs text-amber-600 font-medium uppercase mb-1">Warnings ({warnings.length})</div>
          <ul className="space-y-1">
            {warnings.map((w, i) => (
              <li key={i} className="text-sm text-amber-700 bg-amber-50 rounded px-2 py-1">
                {typeof w === 'object' ? JSON.stringify(w) : w}
              </li>
            ))}
          </ul>
        </div>
      )}

      {checks.length === 0 && errors.length === 0 && warnings.length === 0 && (
        <div className="text-sm text-gray-500 italic">
          {JSON.stringify(val, null, 2).length > 2
            ? <pre className="text-xs text-gray-600 bg-white/60 rounded p-2 overflow-x-auto">{JSON.stringify(val, null, 2)}</pre>
            : 'No validation details available.'}
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Contract165View â€” main component
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const Contract165View = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  if (!execution?.outputData) {
    return (
      <div className="h-full flex items-center justify-center text-gray-400">
        <div className="text-center">
          <Layers className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p>Nessun output disponibile</p>
        </div>
      </div>
    );
  }

  const { render_ir, compilation_metadata, compilation_validation } = execution.outputData;
  const irSections = Object.entries(render_ir || {});

  // sezione execution_graph aperta di default (o la prima disponibile)
  const defaultOpenKey = render_ir?.execution_graph ? 'execution_graph' : (irSections[0]?.[0] ?? null);

  return (
    <div className="h-full overflow-y-auto">
      <div className="space-y-4 max-w-4xl mx-auto p-6">

        {/* Header */}
        <IRHeader renderIr={render_ir} compilationMetadata={compilation_metadata} />

        {/* Render IR sections */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <div className="flex items-center gap-2 mb-4">
            <Code2 className="w-5 h-5 text-violet-500" />
            <h3 className="font-semibold text-gray-800">Render IR Sections</h3>
            <span className="ml-auto text-xs text-gray-400 bg-gray-100 rounded-full px-2 py-0.5">
              {irSections.length} sections
            </span>
          </div>
          <div className="space-y-2">
            {irSections.length > 0 ? (
              irSections.map(([key, value]) => (
                <IRSectionCard
                  key={key}
                  sectionKey={key}
                  sectionData={value}
                  defaultOpen={key === defaultOpenKey}
                />
              ))
            ) : (
              <div className="text-sm text-gray-400 italic">render_ir vuoto</div>
            )}
          </div>
        </div>

        {/* Raw render_ir fallback if flat structure */}
        {irSections.length === 0 && render_ir && (
          <IRSectionCard sectionKey="render_ir" sectionData={render_ir} defaultOpen={true} />
        )}

        {/* Compilation Metadata */}
        {compilation_metadata && (
          <MetadataCard compilationMetadata={compilation_metadata} />
        )}

        {/* Compilation Validation */}
        {compilation_validation && (
          <ValidationCard compilationValidation={compilation_validation} />
        )}

        {/* ReviewGate */}
        <ReviewGate
          execution={execution}
          onApprove={onApprove}
          onReject={onReject}
          onRegenerate={onRegenerate}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Contract165View;
